import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { brandStats } from '@/mocks/data';
import { useState, FormEvent } from 'react';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9qq3hknlsngrm4lm3r0';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Breadcrumb />
      <main>
        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                关于皇冠体育
              </h1>
              <p className="text-sm text-foreground-500 max-w-2xl mx-auto">
                亚洲领先的专业体育竞技平台，15年品牌历史，服务超过500万用户
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-14">
              {brandStats.map((stat, index) => (
                <div
                  key={index}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center"
                >
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                    <i className={`${stat.icon} text-lg text-accent-700`}></i>
                  </div>
                  <p className="text-2xl font-bold text-foreground-900 mb-1">{stat.value}</p>
                  <p className="text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 mb-14">
              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 mb-4">
                  <i className="ri-building-2-line text-lg text-primary-500"></i>
                </div>
                <h2 className="text-lg font-heading font-bold text-foreground-900 mb-3">品牌介绍</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  皇冠体育成立于2011年，总部位于亚洲博彩中心，是经合法授权运营的专业体育竞技平台。经过15年的稳健发展，皇冠体育已成为亚洲地区最具影响力的体育博彩品牌之一。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  平台覆盖足球、篮球、网球、电竞等数百项体育赛事，为用户提供实时赔率、专业赛事分析和安全便捷的投注体验。我们与全球50余家顶级博彩数据供应商和赛事机构建立了深度合作关系，确保赔率准确性和赛事覆盖的全面性。
                </p>
              </div>

              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                  <i className="ri-shield-check-line text-lg text-accent-700"></i>
                </div>
                <h2 className="text-lg font-heading font-bold text-foreground-900 mb-3">品牌信誉</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  皇冠体育始终将用户信任放在首位。我们采用国际领先的SSL加密技术和严格的资金隔离管理制度，确保每一位用户的个人信息和资金安全。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  平台持有合法的博彩运营牌照，运营过程严格遵守国际博彩行业规范和反洗钱法规。所有游戏结果均通过第三方独立审计机构验证，确保公平公正。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们倡导"理性博彩，健康娱乐"的理念，为用户提供自我限额、冷静期等责任博彩工具，并设有24小时专业客服团队，随时解答用户的疑问。
                </p>
              </div>
            </div>

            <div className="max-w-4xl mx-auto">
              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                  <i className="ri-customer-service-2-line text-lg text-secondary-600"></i>
                </div>
                <h2 className="text-lg font-heading font-bold text-foreground-900 mb-4">联系我们</h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-6">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-50 flex-shrink-0">
                      <i className="ri-phone-line text-primary-500"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400 mb-0.5">客服热线</p>
                      <p className="text-sm font-semibold text-foreground-900">+852-3008-8888</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-50 flex-shrink-0">
                      <i className="ri-mail-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400 mb-0.5">电子邮箱</p>
                      <p className="text-sm font-semibold text-foreground-900">service@huangguan-sports.com</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-50 flex-shrink-0">
                      <i className="ri-time-line text-secondary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400 mb-0.5">服务时间</p>
                      <p className="text-sm font-semibold text-foreground-900">7×24小时全天候</p>
                    </div>
                  </div>
                </div>

                <div className="border-t border-background-200/60 pt-6">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-4">在线留言</h3>
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于皇冠体育',
          description: '皇冠体育是亚洲领先的专业体育竞技平台，15年品牌历史，服务超过500万用户。',
          url: 'https://www.huangguan-sports.com/about',
        })}
      </script>
    </>
  );
}

function ContactForm() {
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState<{ type: 'success' | 'error'; message: string } | null>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();

    if (honeypot) {
      setStatus({ type: 'success', message: '留言已提交成功，我们会尽快与您联系！' });
      form.reset();
      return;
    }

    setSubmitting(true);
    setStatus(null);

    try {
      const response = await fetch(CONTACT_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus({ type: 'success', message: '留言已提交成功，我们会尽快与您联系！' });
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '提交失败，请稍后再试';
        if (typeof serverMsg === 'string' && serverMsg.includes('spam')) {
          setStatus({ type: 'success', message: '留言已提交成功，我们会尽快与您联系！' });
          form.reset();
        } else {
          setStatus({ type: 'error', message: typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后再试' });
        }
      }
    } catch {
      setStatus({ type: 'error', message: '网络异常，提交失败，请稍后再试' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} data-readdy-form="" id="contact-form" className="space-y-4">
      <div className="honeypot-wrapper">
        <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-600 mb-1">姓名</label>
          <input type="text" id="contact-name" name="name" required className="w-full px-3 py-2 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400" placeholder="请输入您的姓名" />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-600 mb-1">邮箱</label>
          <input type="email" id="contact-email" name="email" required className="w-full px-3 py-2 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400" placeholder="请输入您的邮箱" />
        </div>
      </div>
      <div>
        <label htmlFor="contact-subject" className="block text-xs font-medium text-foreground-600 mb-1">主题</label>
        <input type="text" id="contact-subject" name="subject" required className="w-full px-3 py-2 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400" placeholder="请输入留言主题" />
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-600 mb-1">留言内容</label>
        <textarea id="contact-message" name="message" required rows={4} maxLength={500} className="w-full px-3 py-2 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 resize-none" placeholder="请输入您的留言内容（500字以内）"></textarea>
      </div>
      {status && (
        <div className={`text-sm px-4 py-2.5 rounded-md ${status.type === 'success' ? 'bg-accent-50 text-accent-800' : 'bg-primary-50 text-primary-700'}`}>
          {status.message}
        </div>
      )}
      <button
        type="submit"
        disabled={submitting}
        className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 disabled:opacity-50 transition-colors whitespace-nowrap cursor-pointer"
      >
        {submitting ? '提交中...' : '提交留言'}
      </button>
    </form>
  );
}